import { Component, OnInit } from '@angular/core';
import {
  BusinessuserService,
  BusinessUserFilter
} from '../../../../services/businessuser.service';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { BusinessUserResource } from 'src/app/interfaces/business-user-resource';
import { OverlayService } from 'src/app/services/overlay.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { environment } from 'src/environments/environment';
import { HttpParams } from '@angular/common/http';


@Component({
  selector: 'app-business-user',
  templateUrl: './business-user.component.html',
  styleUrls: ['./business-user.component.scss']
})
export class BusinessUserComponent implements OnInit {
  users = [];
  page = null;
  test = {
    pageIndex: 0,
    pageSize: 12
  }


  states = [
    { value: "ACTIVE", viewValue: "Aktiv" },
    { value: "PENDING", viewValue: "Wartend" },
    { value: "DISABLE_REQUEST", viewValue: " Deaktivierung beantragt" },
    { value: "REJECTED", viewValue: "Abgelehnt" },
    { value: "DISABLED", viewValue: "Deakiviert" },
    { value: "DELETED", viewValue: "Gelöscht" },
    { value: "NEW", viewValue: "Neu" },
  ]


  roles = [
    { value: "ROLE_ADMIN", viewValue: "Administrator" },
    { value: "ROLE_CASEWORKER", viewValue: "Sachbearbeiter" },
    { value: "ROLE_SERVICE", viewValue: "Webservice" },
    { value: "ROLE_PARTNER", viewValue: "Aktionspartner" },
    { value: "ROLE_CUSTOMER", viewValue: "Kunde" },
    { value: "ROLE_PRE_CUSTOMER", viewValue: "Vorkunde" },
    { value: "ROLE_ANON", viewValue: "Anonymous" },

  ]
  loading: boolean = true;
  showMoreFilter: boolean = false;
  filterForm: UntypedFormGroup;
  dataSource: MatTableDataSource<BusinessUserResource>;
  isActive = false;
  isFormFilterActivate: boolean = false;
  isFormFilterDeactivate: boolean = false;
  // 'contracts',
  displayedColumns = ['number', 'user', 'address', 'contact', 'type', 'state', 'menu'];

  constructor(
    private businessuserService: BusinessuserService,
    private fb: UntypedFormBuilder,
    private overlay: OverlayService,
    private environment: EnvironmentService,
    private route: ActivatedRoute,
    private router: Router) {

    this.filterForm = this.fb.group({
      searchTerm: [null],
      filterByRoles: [null],
      filterByState: [null],
      type: [null],
    })


    this.route.queryParams.subscribe((params:any)=>{
      this.filterForm.patchValue({
        filterByRoles: ((params?.filterByRoles != '') ? params?.filterByRoles?.split(',') : null),
        filterByState: ((params?.filterByState != '') ? params?.filterByState?.split(',') : null),
      })
    })


    // let extras = this.router.getCurrentNavigation()?.extras?.state;
    // if (extras) {
    //   if (extras.filterByState[0] == "PENDING") {
    //     this.isFormFilterActivate = true;
    //   } else if (extras.filterByState[0] == "DISABLE_REQUEST") {
    //     this.isFormFilterDeactivate = true;
    //   }
    //   // this.filterForm.markAllAsTouched();
    //   // this.filterForm.patchValue({
    //   //   searchTerm: extras?.searchTerm,
    //   //   filterByCardState: extras?.filterByCardState,
    //   //   erpState: extras?.erpState,
    //   //   filterByCustomerType: extras?.filterByCustomerType,
    //   //   hasNoValidELV: extras?.hasNoValidELV,
    //   //   filterByState: extras?.filterByState,
    //   //   hasNoCard: extras?.hasNoCard
   // // })
  //  }


  }

  ngOnInit() {
    this.businessuserService.search(this.test.pageIndex, this.test.pageSize, this.filterForm.value.searchTerm, this.filterForm.value.filterByRoles, this.filterForm.value.filterByState, this.filterForm.value.type).subscribe((fromSearch: PagedResources<BusinessUserResource>) => {
      this.page = fromSearch.page;
      fromSearch.content.forEach(user => {
        this.businessuserService.getGroupMemersByID(user.publicId).subscribe(el => {
          user['household'] = el;
        })
      });
      this.dataSource = new MatTableDataSource(fromSearch.content);
      this.loading = false;
    })


  }

  loadPage(event?: PageEvent) {
    this.test.pageIndex = event.pageIndex;
    this.test.pageSize = event.pageSize;
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          page: event.pageIndex,
          size: event.pageSize
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        return this.search(event.pageIndex, event.pageSize);
      })
  }

  search(pageIndex, pageSize) {
    this.loading = true;
    this.businessuserService.search(pageIndex, pageSize, this.filterForm.value.searchTerm, this.filterForm.value.filterByRoles, this.filterForm.value.filterByState, this.filterForm.value.type).subscribe((users: PagedResources<BusinessUserResource>) => {
      this.page = users.page
      users.content.forEach(user => {
        this.businessuserService.getGroupMemersByID(user.publicId).subscribe(el => {
          user['household'] = el;
        })
      });
      this.loading = false;
      this.dataSource = new MatTableDataSource(users.content);
    })
  }

  filterCustomers() {
    this.loading = true;
    this.isFormFilterActivate = false;
    this.isFormFilterDeactivate = false;
    this.filterForm.markAllAsTouched();

    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          page: this.test.pageIndex,
          size: this.test.pageSize,
          filterByState: this.filterForm.value?.filterByState?.join(),
          filterByRoles: this.filterForm.value?.filterByRoles?.join(),
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        this.businessuserService.search(this.test.pageIndex, this.test.pageSize, this.filterForm.value.searchTerm, this.filterForm.value.filterByRoles, this.filterForm.value.filterByState, this.filterForm.value.type).subscribe((users: PagedResources<BusinessUserResource>) => {
          this.page = users.page
          users.content.forEach(user => {
            this.businessuserService.getGroupMemersByID(user.publicId).subscribe(el => {
              user['household'] = el;
            })
          });
          this.loading = false;
          this.dataSource = new MatTableDataSource(users.content);
        })
      })


  }

  showmoreFilters() {
    this.showMoreFilter = true;
  }

  showLessFilters() {
    this.showMoreFilter = false;
  }

  resetFilter() {
    this.filterForm.reset();
    this.search(this.test.pageIndex, this.test.pageSize);
  }

  changeState(customer,state:String) {
    this.loading = true;
    this.businessuserService.changeState(customer, state).subscribe(value => {
      if (value) {
        if(state == 'ACTIVE'){
          this.overlay.openSnackBar("Nutzer aktiviert!");
        }else if(state == 'DELETED'){
          this.overlay.openSnackBar("Nutzer gelöscht!");
        }else if(state == 'DISABLED') {
          this.overlay.openSnackBar("Nutzer deaktiviert!");
        }       
        this.businessuserService.search(this.test.pageIndex, this.test.pageSize, this.filterForm.value.searchTerm, this.filterForm.value.filterByRoles, this.filterForm.value.filterByState, this.filterForm.value.type).subscribe((users: PagedResources<BusinessUserResource>) => {
          this.page = users.page
          users.content.forEach(user => {
            this.businessuserService.getGroupMemersByID(user.publicId).subscribe(el => {
              user['household'] = el;
            })
          });
          this.loading = false;
          this.dataSource = new MatTableDataSource(users.content);
        })
      }
    })
  }


  deactivateUserForever(customer) {
    this.businessuserService.deactivateUserForever(customer).subscribe(value => {
      if (value) {
        this.overlay.openSnackBar("Nutzer erfolgreich deaktiviert!");
        this.businessuserService.search(this.test.pageIndex, this.test.pageSize, this.filterForm.value.searchTerm, this.filterForm.value.filterByRoles, this.filterForm.value.filterByState, this.filterForm.value.type).subscribe((users: PagedResources<BusinessUserResource>) => {
          this.page = users.page
          users.content.forEach(user => {
            this.businessuserService.getGroupMemersByID(user.publicId).subscribe(el => {
              user['household'] = el;
            })
          });
          this.dataSource = new MatTableDataSource(users.content);
        })
      }
    })
  }

  activateUserWithoutNotification(customer) {
    this.businessuserService.activateUserWithoutNotification(customer).subscribe(value => {
      if (value) {
        this.overlay.openSnackBar("Nutzer erfolgreich aktiviert!");
        this.businessuserService.search(this.test.pageIndex, this.test.pageSize, this.filterForm.value.searchTerm, this.filterForm.value.filterByRoles, this.filterForm.value.filterByState, this.filterForm.value.type).subscribe((users: PagedResources<BusinessUserResource>) => {
          this.page = users.page
          users.content.forEach(user => {
            this.businessuserService.getGroupMemersByID(user.publicId).subscribe(el => {
              user['household'] = el;
            })
          });
          this.dataSource = new MatTableDataSource(users.content);
        })
      }
    })
  }


  activateUserWithNotification(customer) {
    this.businessuserService.activateUserWithNotification(customer).subscribe(value => {
      if (value) {
        this.overlay.openSnackBar("Nutzer erfolgreich aktiviert!");
        this.businessuserService.search(this.test.pageIndex, this.test.pageSize, this.filterForm.value.searchTerm, this.filterForm.value.filterByRoles, this.filterForm.value.filterByState, this.filterForm.value.type).subscribe((users: PagedResources<BusinessUserResource>) => {
          this.page = users.page
          users.content.forEach(user => {
            this.businessuserService.getGroupMemersByID(user.publicId).subscribe(el => {
              user['household'] = el;
            })
          });
          this.dataSource = new MatTableDataSource(users.content);
        })
      }
    })
  }



  downLoadUserDataAsZIP(customer) {
    this.businessuserService.getDSGVOExport(customer).subscribe(val => {
      var a = document.createElement("a");
      const contentType = 'application/zip';
      const blob = new Blob([val], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = `${customer.person.displayName}_export`;
      a.click();
      window.URL.revokeObjectURL(url);
    })
  }

  addMemberViaDialog(user) {
    this.overlay.openAddHouseholdMemberDialog("Haushaltsmitglied anlegen", "", "Anlegen", user).subscribe(val => {
      this.ngOnInit();
    })
  }
  getMembers(user: BusinessUserResource) {
    if (user['household']) {

    } else {
      this.businessuserService.getGroupMemersByID(user.publicId).subscribe(el => {
        user['household'] = el;
      })
    }
  }
  openResetPassword(user) {
    this.overlay.openResetPWUserDialog("Passwort zurücksetzen", "", "Passwort setzen", user)
  }

  onKeydown(event) {
    if (event.key === "Enter") {
      this.filterCustomers()
    }
  }

  deleteUser(user) {
    this.overlay.openDelteUserDialog("Nutzer löschen", "Nutzer wirklich löschen?", "Nutzer löschen", user.publicId)
  }

  customerDisplayName(customer: BusinessUserResource): String {
    switch (environment.clientID) {
      case 129: {
        return `${customer.person?.lastName}  ${customer.person?.firstName}`
      }
      default: {
        return `${customer.person?.firstName}  ${customer.person?.lastName}`
      }
    }

  }
}

